import { render, staticRenderFns } from "./iossList.vue?vue&type=template&id=521095f4"
import script from "./iossList.vue?vue&type=script&lang=js"
export * from "./iossList.vue?vue&type=script&lang=js"
import style0 from "./iossList.vue?vue&type=style&index=0&id=521095f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports